import React from "react";
import { ColumnsType } from "antd/es/table";

// 管理员数据接口
export interface Admin {
  id: string;
  adminAccount: string;
  adminName?: string;
  adminPhone?: string;
  accountStatus: number;
  roles?: string[];
  [key: string]: any;
}

// 管理员选择表格列配置（用于选择对话框）
export const adminSelectColumns: ColumnsType<Admin> = [
  {
    title: "账号",
    dataIndex: "adminAccount",
    key: "adminAccount",
    width: 200,
    ellipsis: true,
  },
];

// 管理员选择对话框配置（用于 GenericModalTable）
export const adminSelectModalConfig = {
  title: "选择管理员",
  width: 600,
  fixedHeight: 500,
  confirmText: "保存",
  cancelText: "取消",
  showConfirm: true,
  showCancel: true,
};

// 选择管理员弹窗底部按钮配置（提供给页面复用）
export const getAdminSelectFooterButtons = (params: {
  onCancel: () => void;
  onOk: () => void;
  loading?: boolean;
}) => {
  return [
    {
      key: "cancel",
      text: adminSelectModalConfig.cancelText,
      type: "default" as const,
      onClick: params.onCancel,
    },
    {
      key: "ok",
      text: adminSelectModalConfig.confirmText,
      type: "primary" as const,
      loading: !!params.loading,
      onClick: params.onOk,
    },
  ];
};